<template>
  <div class="navbar">
    <div class="navbar-container">
      <div class="left-menu">
        <Breadcrumb />
      </div>
      <div class="right-menu">
        <div class="right-menu-item">
          <Notification />
        </div>
        <div class="right-menu-item">
          <el-dropdown trigger="click">
            <i class="mci-icon-setting" />
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="showSwitchLangDialog">
                <span style="display: block">Ngôn ngữ</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="right-menu-item">
          <!-- <i class="mci-icon-maximize" /> -->
          <Screenfull />
        </div>
        <div class="right-menu-item">
          <el-dropdown
            class="avatar-container right-menu-item hover-effect"
            trigger="click"
          >
            <div class="avatar-wrapper">
              <img
                class="user-avatar"
                src="https://st3.depositphotos.com/9998432/13335/v/450/depositphotos_133352156-stock-illustration-default-placeholder-profile-icon.jpg"
                alt=""
              />
              <i class="icon-arrow-down" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <router-link to="/close-shiftwork/index">
                <el-dropdown-item>Đóng ca</el-dropdown-item>
              </router-link>
              <router-link to="/profile/index">
                <el-dropdown-item>Thông tin cá nhân</el-dropdown-item>
              </router-link>
              <el-dropdown-item @click.native="onLogOut"
                >Đăng xuất</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- Select language dialog -->
    <el-dialog
      append-to-body
      title="Switch Language"
      width="40%"
      :visible.sync="showSwitchLang"
    >
      <div style="text-align: center">
        <el-radio-group v-model="language">
          <el-radio label="en">English</el-radio>
          <el-radio label="vi">Tiếng Việt</el-radio>
        </el-radio-group>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { removeToken } from '@/utils/auth.js'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Notification from './Notifications'
import Screenfull from '@/components/Screenfull'
import { logoutApi } from '@/api/auth_service/login'
// import ErrorLog from '@/components/ErrorLog'
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Breadcrumb,
    // eslint-disable-next-line vue/no-unused-components
    Hamburger,
    Notification,
    // eslint-disable-next-line vue/no-unused-components
    Screenfull
    // ErrorLog,
    // SizeSelect,
    // Search
  },
  data() {
    return {
      showSwitchLang: false
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device']),
    language: {
      get() {
        return this.$store.state.app.language
      },
      set(lang) {
        this.$i18n.locale = lang
        this.$store.dispatch('app/setLanguage', lang)
        window.location.reload()
      }
    }
  },
  methods: {
    async onLogOut() {
      await logoutApi()
        .then(() => {
          removeToken()
          localStorage.removeItem('listPath')
          localStorage.removeItem('authorizedList')
          localStorage.removeItem('UserInfo')
          this.$router.push('/login')
        })
        .catch(() => {
          this.$message({
            message: 'Có lỗi xảy ra khi đăng xuất, thử lại sau',
            type: 'error'
          })
        })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    showSwitchLangDialog() {
      this.showSwitchLang = true
    },
    async logout() {
      // await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 70px;
  // overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  border-bottom: 1px solid #dedfe7;

  .navbar-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    padding: 0 20px;
  }

  .left-menu {
    display: flex;
    flex: 1;
    align-items: center;
    // transform: translateY(-11px);

    .icon-home {
      display: inline-block;
      width: 24px;
      height: 24px;
      padding: 8px;
      box-sizing: content-box;
      // margin-right: 10px;
      background: url('../../styles/images/svg/mci_home_icon.svg') no-repeat 50%
        50%;
    }

    select {
      width: 242px;
      margin-left: 10px;
      border-radius: 6px;
    }
  }

  .right-menu {
    display: flex;
    align-items: center;
    gap: 20px;

    .right-menu-item {
      cursor: pointer;

      .avatar-container {
        .avatar-wrapper {
          .user-avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
          }

          .icon-arrow-down {
            position: relative;
            top: -10px;
            margin-left: 5px;
            display: inline-block;
            width: 12px;
            height: 12px;
            box-sizing: content-box;
            // margin-right: 10px;
            background: url('../../styles/images/svg/mci_arrow-down.svg')
              no-repeat 50% 50%;
          }
        }
      }
    }
  }
}
</style>
